import {Injectable} from "@angular/core";
import {Chart} from "chart.js";
import {ExportChartImage} from "./export-chart-image";

@Injectable({
  providedIn: 'root'
})

/*
01/09/2025 - Kauan
processo similar ao do processamento das barras horizontais, mas os valores sao printados acima da barra caso sejam receita e abaixo caso sejam despesa
*/

export class ProcessConsolidacaoChart {

  constructor(private exportChartImage: ExportChartImage) {}

  process(chart : any) : void {
    chart.options.layout.padding.top = 30;
    chart.options.layout.padding.bottom = 30;
    chart.options.animation.duration = 1;
    chart.options.animation.onComplete = function(){
      let chartInstance = this;
      let ctx = chartInstance.ctx;
      ctx.font = Chart.helpers.fontString(10, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
      ctx.textAlign = 'center';
      ctx.fillStyle = '#666665';
      ctx.textBaseline = 'bottom';
      this.data.datasets.forEach(function(dataset) {
        let i;
        if (dataset.label === "Receita"){
          for (i = 0; i < dataset.data.length; i++) {
            let model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
            if (dataset.data[i] > 0){
              ctx.fillText(new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }).format(dataset.data[i]), model.x, model.y - 5);
            }
          }
        }
        if (dataset.label === "Despesa"){
          for (i = 0; i < dataset.data.length; i++) {
            let model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
            if (dataset.data[i] < 0){
              ctx.fillText(new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }).format(dataset.data[i]), model.x, model.y + 15);
            }
          }
        }
      });
    };

    chart.update();

    setTimeout( () =>{
      this.exportChartImage.save('myChart2');
    }, 100);

    setTimeout( () =>{
      this.undoChanges(chart);
    }, 1000);
}

  undoChanges(chart: any) : void {
    chart.options.layout.padding.top = 0;
    chart.options.layout.padding.bottom = 0;
    chart.options.animation.duration = 30;
    chart.options.animation.onComplete = function () {};
    chart.update();
  }
}
